<section
	[editableInStoryblok]="_editable()"
	data-test-class="image-slider-section"
>
	<div class="section-gap gap-8 section-spacing-y md:gap-12 lg:gap-16">
		@if (heading(); as heading) {
			<div class="section-spacing-x">
				<div class="section-inner section-gap md:flex-row">
					<div class="md:w-1/3">
						<sb-heading-group-section
							[headingType]="heading.headingType"
							[overline]="heading.overline"
							[title]="heading.title"
							alignment="left"
						/>
					</div>
					<div class="flex flex-col gap-4 md:w-2/3 md:gap-6">
						@if (content()) {
							<sb-markdown [content]="content()" />
						}
						@if (button()?.[0]; as button) {
							<sb-anchor
								[link]="button.link"
								[text]="button.text"
								type="primary"
								variant="underline"
							/>
						}
					</div>
				</div>
			</div>
		}
		@if (slides().length > 0) {
			<vp-slider
				[config]="sliderConfig"
				[itemTemplate]="slideTpl"
				[items]="slides()"
				[label]="sliderLabel()"
				[navTemplate]="navTpl"
				[trackFn]="trackBySrc"
				[uid]="_uid()"
			/>
			<ng-template #slideTpl let-index="index" let-slide>
				<vp-asymmetric-image-slide [image]="slide" [index]="index" />
			</ng-template>
			<ng-template #navTpl let-nav>
				<vp-slider-nav-button
					[disabled]="!nav.canScrollPrev"
					(pressed)="nav.scrollPrev()"
					direction="prev"
					variant="light"
				/>
				<vp-slider-nav-button
					[disabled]="!nav.canScrollNext"
					(pressed)="nav.scrollNext()"
					direction="next"
					variant="light"
				/>
			</ng-template>
		}
	</div>
</section>
